import { useEffect } from 'react';
import { triggerWootricSurvey } from '../utils/triggerWootricSurvey';
export const useWootricSurvey = () => {
  useEffect(() => {
    try {
      if (window.localStorage && window.localStorage['wootric-nps-open'] === 'false') {
        return;
      }
      triggerWootricSurvey();
    } catch (e) {
      triggerWootricSurvey();
    }
  }, []);
};